const NintendoIcon = props => {
  return (
    <svg fill={props.color} width={props.width} height={props.height} viewBox="0 0 48 37" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.116 3.7H14.884C8.719 3.7 3.72 8.67 3.72 14.8v7.4c0 6.13 4.998 11.1 11.163 11.1h18.232c6.165 0 11.163-4.97 11.163-11.1v-7.4c0-6.13-4.998-11.1-11.163-11.1ZM14.884 0C6.664 0 0 6.626 0 14.8v7.4C0 30.374 6.664 37 14.884 37h18.232C41.336 37 48 30.374 48 22.2v-7.4C48 6.626 41.336 0 33.116 0H14.884Z"
        fill={props.color}
      />
      <path
        d="M18.456 26.853c-.667 0-1.175-.174-1.524-.52-.35-.348-.524-.861-.524-1.54V11.887c0-.694.174-1.223.524-1.586.349-.38.81-.569 1.38-.569.509 0 .906.095 1.192.285.285.19.603.505.952.947l7.55 9.377h-.668V11.77c0-.663.167-1.168.5-1.516.35-.347.858-.52 1.525-.52.666 0 1.166.173 1.5.52.35.348.524.853.524 1.516v13.119c0 .6-.159 1.081-.477 1.444-.317.347-.746.521-1.285.521-.54 0-.969-.095-1.286-.284-.302-.205-.627-.521-.977-.947l-7.549-9.401h.667v8.572c0 .679-.175 1.192-.524 1.54-.333.346-.833.52-1.5.52Z"
        fill={props.color}
      />
    </svg>
  );
};

export default NintendoIcon;
